module.exports = {
  init() {
    let io = new IntersectionObserver(this.handleIntersection, { threshold: [0, 1] });
    document.querySelectorAll('.mo2022_altrow img').forEach((elem) => {
      io.observe(elem);
    })
  },
  handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (entry.intersectionRatio == 1) {
          entry.target.classList.add('onscreen');
        }
      } else {
        entry.target.classList.remove('onscreen');
      }
    })
  }
} 